import React from 'react';
import {
    withStyles,
    Typography,
    ListItem,
    Avatar,
    Grid,
} from '@material-ui/core';
import MBack from '../view/MBack';

import DefaultAvatarImg from '../../images/change/default_avatar.png';
import { withRouter } from 'react-router-dom';
import DateUtils from '../../control/dateutils';
import { ListView } from 'antd-mobile'; 


const SVIP_ICON = require('../../images/change/default_avatar.png')

class SysMessage extends React.Component {

    constructor(props) {
        super(props);
        this.ds = new ListView.DataSource({
            rowHasChanged: (r1, r2) => r1 !== r2
        });
    }

    _renderItem = (data, sectionID, rowID) => {
        const { classes } = this.props;
        return (
            <Grid key={rowID} container direction='column' alignItems='center'>
                <ListItem style={{ alignItems: 'flex-start', justifyContent: 'center', paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0 }}>
                    <Typography style={{ color: '#878787', fontSize: 11 }}>{DateUtils.dateFormatMDHM(data.addTime)}</Typography>
                </ListItem>
                <ListItem style={{ alignItems: 'flex-start', paddingLeft: 8, paddingRight: 8 }}>
                    <Avatar className={classes.avatar} src={SVIP_ICON} />
                    <div className={classes.rightp}>{data.content} </div>
                </ListItem>
            </Grid>
        );
    }

    render() {
        const { data } = this.props.location;
        return (
            <MBack title={'官方通知'} backgroundColor='#F7F7F7'>
                <ListView
                    initialListSize={data.length}
                    listPrefixCls='padding: 0px'
                    style={{ width: '100vw', height: 'calc(100vh - 48px)', maxWidth: '100%', padding: 0, paddingTop: 8 }}
                    contentContainerStyle={{ width: '100%', padding: 0 }}
                    dataSource={this.ds.cloneWithRows(data)}
                    renderRow={this._renderItem}
                    pageSize={10}
                    useBodyScroll={false}
                    onEndReachedThreshold={10}
                >
                </ListView>
            </MBack >
        );
    }
}
export default withRouter(withStyles((theme) => ({
    avatar: {
        width: 50,
        height: 50,
        color: '#fff',
        marginTop: 0,
        backgroundSize: 'cover',
        backgroundImage: `url(${DefaultAvatarImg})`,
    },
    rightp: {
        color: '#0D0D0D',
        backgroundColor: '#fff',
        padding: theme.spacing(1, 1, 1, 1),
        borderRadius: 5,
        margin: theme.spacing(1, 1, 1, 1),
        fontSize: theme.typography.pxToRem(13),
        maxWidth: 'calc(100% - 132px)'
    }
}))(SysMessage));
